import React from 'react';
import { Select, Typography } from 'antd';
import { DateRangePicker, presetPeriod } from '@prerender/design-system/DateRangePicker';

import { FilterBar } from '~components/Filters';
import { DISPLAY_LOCALE } from '~library/dates';
import { REPORTING_WINDOW_PRESET, getReportingWindow } from './SearchPerformanceReportingWindow';
import useSearchPerformanceProperty from './useSearchPerformanceProperty';
import useTrackSearchPerformanceEvent from './useTrackSearchPerformanceEvent';

// Googlebot is the only crawler Search Console reports on, so this is a static
// display rather than a filter — one option, permanently disabled. It stays a
// Select so the row reads consistently with the controls beside it.
const CRAWLER_OPTIONS = [{ value: 'googlebot', label: 'Googlebot' }];

const REPORTING_WINDOW_PRESETS = [REPORTING_WINDOW_PRESET];
const REPORTING_WINDOW_PERIOD = presetPeriod(REPORTING_WINDOW_PRESET);

function SearchPerformanceFilters() {
  const { properties, isLoading, selectedProperty, selectProperty } = useSearchPerformanceProperty();
  const trackEvent = useTrackSearchPerformanceEvent();

  const handlePropertyChange = (propertyUrl: string) => {
    trackEvent('Search Performance: Domain Selector Changed', {
      from_domain: selectedProperty?.propertyUrl ?? '',
      to_domain: propertyUrl,
      domain: propertyUrl,
    });
    selectProperty(propertyUrl);
  };
  // Read-only display of the fixed reporting window — a changeable picker
  // would move the dates without moving the figures. Sharing rules: AGENTS.md.
  const { from, end } = getReportingWindow();

  const propertyOptions = properties.map((property) => ({
    value: property.propertyUrl,
    label: property.isDisconnected ? (
      <>
        {property.propertyUrl} <Typography.Text type="secondary">(disconnected)</Typography.Text>
      </>
    ) : (
      property.propertyUrl
    ),
  }));

  return (
    <FilterBar>
      <Select
        aria-label="Which Search Console property these figures cover"
        style={{ width: 260 }}
        loading={isLoading}
        options={propertyOptions}
        value={selectedProperty?.propertyUrl}
        onChange={handlePropertyChange}
      />

      <Select
        aria-label="Crawler"
        disabled
        style={{ width: 153 }}
        options={CRAWLER_OPTIONS}
        value="googlebot"
      />

      <DateRangePicker
        disabled
        presets={REPORTING_WINDOW_PRESETS}
        defaultPeriod={REPORTING_WINDOW_PERIOD}
        dateFrom={from.toDate()}
        dateTo={end.toDate()}
        onChange={() => undefined}
        dateLocale={DISPLAY_LOCALE}
      />
    </FilterBar>
  );
}

export default SearchPerformanceFilters;
